module.exports = __webpack_public_path__ + "img/pocketball-ico.d56932cf.svg";